import React from "react";
import "./panel.scss";

function Spacer({ spacing = 0, children }) {
  return (
    <div
      className={`grigora-editor-spacer border-b border-gray-200`}
      style={{ padding: spacing }}
    >
      {children}
    </div>
  );
}

export default Spacer;
